import { StatsDetailsTabEnum } from '@/features/gateway/types'
import { useCurrentReflection } from '@/hooks'
import { useRouteModalHistory } from '@/router'
import { useApiQuery } from '@/utils/use-api-query'
import { $t } from 'packages/locale'
import { FC, useContext } from 'react'

import { IndexBoardCard } from '../components/IndexBoardCard'
import { DataBoardContext } from '../context'
import { useStatsApiQuery } from '../utils/query'
import { getDeviceCardTips } from '../utils/tips'

/**
 * 电子违规统计：Header 内联样式（与今日异常考勤同风格）
 */
export const DeviceStatsCard: FC = () => {
  const { semesterInfo, timeRange, role } = useContext(DataBoardContext)
  const reflection = useCurrentReflection()

  const apiQuery = useStatsApiQuery({
    timeRange,
    semesterInfo,
  })

  const { data: res, loading } = useApiQuery({
    apiName: 'queryAdvisorStudentMoralAssessmentStats',
    params: {
      query: apiQuery,
    },
    options: {
      enabled: !!reflection?.usin,
    },
  })

  const { data: deviceStats } = res || {}
  const getInfo = (type: 'phone' | 'pad' | 'self') =>
    deviceStats?.find((item) => item.type === type)

  return (
    <IndexBoardCard
      title={$t('电子违规统计')}
      count={deviceStats?.at(0)?.total_user_count ?? 0}
      items={[
        {
          label: $t('手机或个人设备'),
          value: getInfo('phone')?.type_user_count ?? 0,
        },
        {
          label: $t('学校平板'),
          value: getInfo('pad')?.type_user_count ?? 0,
        },
      ]}
      flex={2}
      type={StatsDetailsTabEnum.StudentDeviceViolation}
      loading={loading}
      tips={getDeviceCardTips(role)}
      itemIconMsg={{
        name: 'Devices',
        color: '#00CC36',
        backgroundColor: '#E8FFEA',
      }}
    />
  )
}
